import "./ExpansionSection.css";

export function ExpansionSection({ children, className = "", expanded, ...props }) {
  return <section className={`expansion-section${expanded ? " expanded" : ""}${className ? ` ${className}` : ""}`} {...props}>{children}</section>;
}
